import React, { FC } from "react";

import { defineMessages, useIntl } from "react-intl";

import Info from "./Info";
import OptionInfo from "./OptionInfo";

const messages = defineMessages({
  absoluteDescription: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.datingMethod.tooltip.absolute.description",
    defaultMessage: "A specific calendar date including month, day, and year.",
  },
  absoluteTitle: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.datingMethod.tooltip.absolute.title",
    defaultMessage: "Absolute",
  },
  ordinalDescription: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.datingMethod.tooltip.ordinal.description",
    defaultMessage: "A specific calendar date including only the month and day, not the year.",
  },
  ordinalTitle: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.datingMethod.tooltip.ordinal.title",
    defaultMessage: "Ordinal",
  },
  relativeDescription: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.datingMethod.tooltip.relative.description",
    defaultMessage:
      "Establishes the order of events relative to the current day without specifying exact dates.",
  },
  relativeTitle: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.datingMethod.tooltip.relative.title",
    defaultMessage: "Relative",
  },
  title: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.datingMethod.tooltip",
    defaultMessage: "About dating methods",
  },
});

export interface DatingMethodInfoProps {}

const DatingMethodInfo: FC<DatingMethodInfoProps> = () => {
  const intl = useIntl();

  return (
    <Info title={intl.formatMessage(messages.title)}>
      <OptionInfo
        description={intl.formatMessage(messages.absoluteDescription)}
        title={intl.formatMessage(messages.absoluteTitle)}
      />{" "}
      <OptionInfo
        description={intl.formatMessage(messages.ordinalDescription)}
        title={intl.formatMessage(messages.ordinalTitle)}
      />{" "}
      <OptionInfo
        description={intl.formatMessage(messages.relativeDescription)}
        title={intl.formatMessage(messages.relativeTitle)}
      />
    </Info>
  );
};

export default DatingMethodInfo;
